/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Review_Pro4Inputs */

const en_fc_home_review_pro4 = /** @type {(inputs: Fc_Home_Review_Pro4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real color tools: curves, wheels, HSL secondaries, LUTs and scopes.`)
};

/**
* | output |
* | --- |
* | "Real color tools: curves, wheels, HSL secondaries, LUTs and scopes." |
*
* @param {Fc_Home_Review_Pro4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_review_pro4 = /** @type {((inputs?: Fc_Home_Review_Pro4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Review_Pro4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_review_pro4(inputs)
});
export { fc_home_review_pro4 as "fc.home.review.pro4" }